import "./style.css"
import loader from "./../../images/Design_-Negative-Mask-Effect-[remix] (1).gif"
const Loader = () => {
  return (
    <div className="loader">
      <img src={loader} alt="" />
    </div>
  );
};

export default Loader;
